import * as React from 'react';
import classnames from 'classnames';
import { ColumnedDropdown } from './ColumnedDropdown.js';
import { COLUMNED_DROPDOWN_PLACEHOLDER } from './constants.js';

const DualColumnDropdown = ({ label , className , options , selectedValue , onChange , isDisabled , hasError  })=>{
    const optionsArray = Object.entries(options).map(([key, value])=>({
            label: key,
            value
        })
    );
    const positiveOptions = optionsArray.filter((power)=>Number(power.value) >= 0
    );
    const negativeOptions = optionsArray.filter((power)=>Number(power.value) <= 0
    );
    negativeOptions.reverse();
    return /*#__PURE__*/ React.createElement(ColumnedDropdown, {
        className: classnames(className),
        options: optionsArray,
        leftColumnOptions: negativeOptions,
        rightColumnOptions: positiveOptions,
        placeholder: selectedValue || COLUMNED_DROPDOWN_PLACEHOLDER,
        onChange: ({ value  })=>onChange(value)
        ,
        "data-t": "prescription-power",
        "aria-label": label,
        "aria-invalid": hasError,
        disabled: isDisabled,
        required: true
    });
};

export { DualColumnDropdown };
//# sourceMappingURL=DualColumnDropdown.js.map
